import type { TenantLifecycleAction, TenantStatus } from "@/entities/tenant/model/types";

/**
 * Transições que o auth-api aceita: só ACTIVE e SUSPENDED se cancelam, e cancelar é terminal.
 * PROVISIONING e FAILED não têm ações de ciclo de vida; FAILED tem o retry à parte.
 */
const ALLOWED_ACTIONS: Record<TenantStatus, readonly TenantLifecycleAction[]> = {
    PROVISIONING: [],
    ACTIVE: ["suspend", "cancel"],
    SUSPENDED: ["reactivate", "cancel"],
    CANCELLED: [],
    FAILED: [],
};

export function allowedLifecycleActions(status: TenantStatus): readonly TenantLifecycleAction[] {
    return ALLOWED_ACTIONS[status];
}

export const SUSPEND_REASON_MIN = 5;
export const SUSPEND_REASON_MAX = 200;

export function isValidSuspendReason(reason: string): boolean {
    const length = reason.trim().length;
    return length >= SUSPEND_REASON_MIN && length <= SUSPEND_REASON_MAX;
}
